((window, $) => {

  $('input').on('keydown change', handleInputChange);

  function handleInputChange(){
    const $form = $(this).parents('form');
    let valid = false;

    const inputs = $form.find('input').filter(function(){
      return $(this).val().trim() === ''
    });

    if (inputs.length === 0) {
      $form.addClass('valid');
      $form.find('[type="submit"]').attr('disabled', false);
    } else {
      $form.removeClass('valid');
      $form.find('[type="submit"]').attr('disabled', true);
    }
  }

})(window, jQuery)